export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const VERIFY_PAYMENT = 'VERIFY_PAYMENT';
